import React from "react";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Imagini
// Services.js
import curateniePostconstruct1 from "../../../../../../assets/images/poze-site/6-1-galerie-posconstruct.webp";
import curateniePostconstruct2 from "../../../../../../assets/images/poze-site/6-2-galerie-postconstruct.webp";
import curateniePostconstruct3 from "../../../../../../assets/images/poze-site/6-3-galerie-postconstruct.webp";
import curateniePostconstruct4 from "../../../../../../assets/images/poze-site/6-4-galerie-postconstructor.webp";
import curateniePostconstruct5 from "../../../../../../assets/images/poze-site/6-5-galerie-postconstruct.webp";
import curateniePostconstruct6 from "../../../../../../assets/images/poze-site/6-6-galerie-postconstruct.webp";
import curateniePostconstruct7 from "../../../../../../assets/images/poze-site/6-7-galerie-postconstruct.webp";
import curateniePostconstruct8 from "../../../../../../assets/images/poze-site/6-8-galerie-postconstruct.webp";
import curateniePostconstruct9 from "../../../../../../assets/images/poze-site/6-9-galerie-postconstruct.webp";

// ca să scapi de "is defined but never used"
const images = [
    curateniePostconstruct1,
    curateniePostconstruct2,
    curateniePostconstruct3,
    curateniePostconstruct4,
    curateniePostconstruct5,
    curateniePostconstruct6,
    curateniePostconstruct7,
    curateniePostconstruct8,
    curateniePostconstruct9,
];

function ServicesSection() {
    return (
        <MKBox py={6}>
            <Container>
                <MKTypography variant="h2" textAlign="center" mb={4}>
                    Galerie foto – Servicii de curățenie post-constructor
                </MKTypography>

                <Grid container spacing={3} justifyContent="center">
                    {images.map((img, index) => (
                        <Grid item xs={12} sm={6} md={4} key={index}>
                            <MKBox
                                component="div"
                                sx={{
                                    position: "relative",
                                    width: "100%",
                                    paddingTop: "70%", // raport 7:10 (poți schimba 100% = pătrat, 56.25% = 16:9 etc.)
                                    overflow: "hidden",
                                    borderRadius: "lg",
                                    boxShadow: 3,
                                }}
                            >
                                <MKBox
                                    component="img"
                                    src={img}
                                    alt={`Galerie curățenie ${index + 1}`}
                                    sx={{
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover", // crop și păstrează proporțiile
                                    }}
                                />
                            </MKBox>
                        </Grid>
                    ))}
                </Grid>

                <MKButton
                    variant="gradient"
                    color="info"
                    size="large"
                    component="a"
                    href="/contact-curatenie"
                    sx={{ mt: 6, mx: "auto", display: "block" }}
                >
                    Solicită o ofertă
                </MKButton>
            </Container>
        </MKBox>
    );
}

export default ServicesSection;
